// extracted by mini-css-extract-plugin
export var csatScore = "_n4-5";
export var header = "_n4-1";
export var panelWrapper = "_n4-2";
export var postPreview = "_n4-3";
export var rightContent = "_n4-0";
export var wrappingText = "_n4-4";